/**
 * Samples.js
 * 
 * Monitors cart and automatically removes product variant 12149059125588
 * if it gets added to the cart.
 */

(function() {
  'use strict';

  const TARGET_PRODUCT_TYPE = 'Avis-add-charge';
  const TIER_LIMITS = {
    SILVER: 1,
    GOLD: 2,
    PLATINUM: 3,
    DIAMOND: 4
  };
  let isRemoving = false;
  let lastCheckTime = 0;
  const CHECK_THROTTLE_MS = 500; // Only check once per 500ms

  function getLoyaltyTier() {
    try {
      if (typeof window !== 'undefined' && window.LOYALTY_TIER) {
        return String(window.LOYALTY_TIER).toUpperCase();
      }
    } catch (_) {}
    return 'NONE';
  }

  function getAllowedUnitsForTier(tier) {
    if (typeof tier !== 'string') return 0;
    const normalized = tier.toUpperCase();
    return TIER_LIMITS[normalized] || 0;
  }

  function updateCartIndicators(cart) {
    try {
      if (!cart || typeof cart.item_count === 'undefined') return;
      document.querySelectorAll('.cart-count').forEach((el) => {
        if (el.classList.contains('cart-count-drawer')) {
          el.innerHTML = `(${cart.item_count})`;
        } else {
          el.innerHTML = cart.item_count;
        }
      });
      if (document.querySelector('header-total-price') && typeof document.querySelector('header-total-price').updateTotal === 'function') {
        document.querySelector('header-total-price').updateTotal(cart);
      }
      const freeShip = document.querySelector('free-ship-progress-bar');
      if (freeShip && typeof freeShip.init === 'function' && typeof cart.items_subtotal_price !== 'undefined') {
        freeShip.init(cart.items_subtotal_price);
      }
    } catch (error) {}
  }

  async function refreshMiniCart(cartData) {
    const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cartElement || typeof cartElement.getSectionsToRender !== 'function') {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
      return;
    }

    try {
      const sections = cartElement.getSectionsToRender().map((section) => section.id || section);
      if (!sections.length) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
        return;
      }

      const url = `${window.location.pathname}?sections=${encodeURIComponent(sections.join(','))}`;
      const response = await fetch(url);
      const parsed = await response.json();
      const parser = new DOMParser();

      sections.forEach((sectionId) => {
        const elementToReplace = document.getElementById(sectionId);
        const sectionHtml = parsed[sectionId];
        if (!elementToReplace || !sectionHtml) return;
        const html = parser.parseFromString(sectionHtml, 'text/html');
        const formMini = html.querySelector('#form-mini-cart');
        if (formMini) {
          elementToReplace.innerHTML = formMini.innerHTML;
        } else if (html.body) {
          elementToReplace.innerHTML = html.body.innerHTML;
        }
        const countdown = cartElement.querySelector('.cart-countdown-time');
        const htmlCountdown = html.querySelector('.cart-countdown-time');
        if (countdown && htmlCountdown) {
          countdown.innerHTML = htmlCountdown.innerHTML;
          if (typeof cartElement.countdownTimer === 'function') {
            cartElement.countdownTimer();
          }
        }
      });

      if (typeof cartElement.cartAction === 'function') {
        cartElement.cartAction();
      }
      if (typeof cartElement.open === 'function') {
        cartElement.open();
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
    } catch (error) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
    }
  }

  /**
   * Remove the target variant from cart
   */
  async function removeTargetVariant(skipThrottle = false) {

    const now = Date.now();
    
    // Throttle checks to prevent infinite loops
    if (!skipThrottle && (now - lastCheckTime < CHECK_THROTTLE_MS)) {
      return;
    }
    lastCheckTime = now;
    
    if (isRemoving) {
      return;
    }
    
    try {
      const response = await fetch('/cart.json');
      const cart = await response.json();
      
      if (!cart || !cart.items) {
        return;
      }

    
      
      const loyaltyTier = getLoyaltyTier();
      const allowedUnits = getAllowedUnitsForTier(loyaltyTier);
      
      const matchingItems = [];
      const skippedItems = [];
      cart.items.forEach(item => {
        if (item.product_type !== TARGET_PRODUCT_TYPE) {
          return;
        }
        const hasApoOrder = item.properties && Object.prototype.hasOwnProperty.call(item.properties, '_apo_order');
        if (hasApoOrder) {
          skippedItems.push(item);
          return;
        }
        matchingItems.push(item);
      });
      
      const totalUnits = matchingItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
      
      if (totalUnits <= allowedUnits) {
        return;
      }
      
      let unitsToRemove = totalUnits - allowedUnits;
      
      const removalOperations = [];
      for (let i = matchingItems.length - 1; i >= 0 && unitsToRemove > 0; i--) {
        const item = matchingItems[i];
        const quantity = Number(item.quantity) || 0;
        if (quantity <= 0) {
          continue;
        }
        const removeQty = Math.min(quantity, unitsToRemove);
        const newQty = quantity - removeQty;
        removalOperations.push({ item, removeQty, newQty });
        unitsToRemove -= removeQty;
      }
      
      if (!removalOperations.length) {
        return;
      }
      
      isRemoving = true;
      let latestCartState = null;
      let totalRemovedUnits = 0;
      
      for (const operation of removalOperations) {
        const targetItem = operation.item;
        
        const removeResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: targetItem.key,
            quantity: operation.newQty
          })
        });
        
        const removeResult = await removeResponse.json();
        latestCartState = removeResult;
        
        if (removeResult && !removeResult.errors) {
          totalRemovedUnits += operation.removeQty;
        } else {
          if (removeResult?.errors) {
            // Swallow API errors silently
          }
        }
      }
      
      if (latestCartState && !latestCartState.errors) {
        updateCartIndicators(latestCartState);
        await refreshMiniCart(latestCartState);
      }
      
      document.dispatchEvent(new CustomEvent('sampleVariantRemoved', {
        detail: {
          product_type: TARGET_PRODUCT_TYPE,
          loyalty_tier: loyaltyTier,
          allowed_units: allowedUnits,
          removed_units: totalRemovedUnits,
          skipped_items: skippedItems
        }
      }));
      
      isRemoving = false;
    } catch (error) {
      isRemoving = false;
    }
  }

  /**
   * Intercept fetch requests to monitor cart adds
   */
  function interceptCartAdds() {
    const originalFetch = window.fetch;
    
    window.fetch = async function(...args) {
      const response = await originalFetch.apply(this, args);
      const url = args[0];
      
      // Only process cart-related requests
      if (typeof url === 'string') {
        const isCartAdd = url.includes('/cart/add');
        const isCartChange = url.includes('/cart/change');
        
        if (isCartAdd) {
          setTimeout(() => {
            removeTargetVariant();
          }, 200);
        } else if (isCartChange) {
          if (!isRemoving) {
            setTimeout(() => {
              removeTargetVariant();
            }, 200);
          }
        }
      }
      
      return response;
    };
  }

  /**
   * Monitor cart updates via events
   */
  function setupEventListeners() {
    // Listen for custom cart update events
    document.addEventListener('cart:updated', () => {
      setTimeout(() => removeTargetVariant(), 200);
    });
    
    // Listen for Avada cart events
    document.addEventListener('avada:cart:change', () => {
      setTimeout(() => removeTargetVariant(), 200);
    });
  }

  /**
   * Initialize the script
   */
  function init() {
    interceptCartAdds();
    setupEventListeners();
    
    // Check on page load (skip throttle for initial check)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          removeTargetVariant(true);
        }, 500);
      });
    } else {
      setTimeout(() => {
        removeTargetVariant(true);
      }, 500);
    }
  }

  // Initialize when script loads
  init();
})();

